class PlatformUtil {
    // --------------   平台   ------------------
    static isMobile() {
        return /(mobile)/i.test(navigator.userAgent);
    }
    static isAndroid() {
        return /(android)/i.test(navigator.userAgent);
    }
    static isIOS() {
        return /(iphone|ipad|ipod)/i.test(navigator.userAgent);
    }
    static isIPad() {
        return /(ipad)/i.test(navigator.userAgent);
    }
    static isMac() {
        return !this.isMobile() && /Mac OS X/i.test(navigator.userAgent);
    }
    // --------------   浏览器   ------------------
    static isFireFox() {
        return /firefox/i.test(navigator.userAgent);
    }
    static isChrome() {
        return /chrome/i.test(navigator.userAgent);
    }
}

export { PlatformUtil };
//# sourceMappingURL=platform-utils.js.map
